module.exports = __webpack_public_path__ + "static/img/chart_bg.50bdd3f5.png";